import React from 'react';
import {CircularProgress, Grid} from "@mui/material";
import Lottie from "react-lottie";
import walletLoading from "../../assets/lotties/loading.json";

const LoadingScreen = () => {
    return (
        <div>
            <Grid container justifyContent={'center'} direction={"column"} alignContent={"center"}
                  alignItems={"center"} sx={{minHeight: '100vh'}}>
                <Lottie
                    options={{
                        loop: true,
                        autoplay: true,
                        animationData: walletLoading,
                        rendererSettings: {
                            preserveAspectRatio: "xMidYMid slice"
                        }
                    }}
                    height={400}
                    width={400}
                />
            </Grid>
        </div>
    );
};

export default LoadingScreen;
